import React from 'react';
import useTranslate from '../../../Hooks/useTranslate';
import { Box, Typography } from '@mui/material';
import IconButton from '../../../Components/Button/IconButton';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

const BackButton = function BackButton({ onClick, label }) {
  const translate = useTranslate();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '4px',
        alignItems: 'center',
      }}
    >
      <IconButton id="back-icnBtn" onClick={onClick} title="BACK">
        <ArrowBackRoundedIcon />
      </IconButton>
      <Typography variant="overline" sx={{ color: '#5A5A5A', fontSize: '1rem' }}>
        {translate(label)}
      </Typography>
    </Box>
  );
};

export default BackButton;
